import type { PropsWithChildren } from 'react'
import { DatabaseBootstrap } from '@/app/DatabaseBootstrap'
import { GlobalErrorListener } from '@/app/GlobalErrorListener'
import { PwaUpdatePrompt } from '@/app/PwaUpdatePrompt'
import { NotificationProvider } from '@/components'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <NotificationProvider>
      <DatabaseBootstrap>
        <GlobalErrorListener />
        {children}
        <PwaUpdatePrompt />
      </DatabaseBootstrap>
    </NotificationProvider>
  )
}
